module.exports = __webpack_public_path__ + "img/deleteBtnSvg.9f052633.svg";